import { render, staticRenderFns } from "./BalancedMonthlyGoalInsight.vue?vue&type=template&id=153e7286&scoped=true"
import script from "./BalancedMonthlyGoalInsight.vue?vue&type=script&lang=js"
export * from "./BalancedMonthlyGoalInsight.vue?vue&type=script&lang=js"
import style0 from "./BalancedMonthlyGoalInsight.vue?vue&type=style&index=0&id=153e7286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153e7286",
  null
  
)

export default component.exports